import React from 'react'
import { Form, Input, InputNumber, DatePicker, Select } from 'antd';

const SECTION_TYPE = [
    {
        value: 'section',
        label: 'Sección',
    },
    {
        value: 'area',
        label: 'Área',
    }
]

const FormIteamInformation = ({
    color,
    changeColor
}) => {
    return (
        <>
            <Form.Item
                name="name"
                label="Nombre"
                rules={[{ required: true, message: 'Por favor ingresa el nombre' }]}
            >
                <Input />
            </Form.Item>
            <Form.Item
                name="year"
                label="Año"
                rules={[{ required: true, message: 'Por favor ingresa el año' }]}
            >
                <DatePicker className='w-full' picker="year" format="YYYY" />
            </Form.Item>
            <div className="flex flex-col gap-3 mb-4">
                <label htmlFor="color">Color</label>
                <div className="flex items-center gap-2">
                    <input
                        className="w-6 h-[26px] bg-transparent px-[1px] border border-[#E6E6E6] rounded-md"
                        type="color"
                        name="color"
                        value={color}
                        onChange={changeColor}
                    />
                    <span className='text-xs'>{color}</span>
                </div>
            </div>
            <Form.Item
                name="installed_capacity"
                label="Capacidad Instalada"
                rules={[{ required: true, message: 'Por favor ingresa la capacidad instalada' }]}
            >
                <InputNumber className='w-full' min={1} />
            </Form.Item>
            <Form.Item
                name="type"
                label="Tipo"
                rules={[{ required: true, message: 'Por favor ingresa el tipo' }]}
            >
                <Select
                    placeholder="Selecciona el tipo"
                    style={{ width: '100%' }}
                    options={SECTION_TYPE}
                />
            </Form.Item>
        </>
    )
}

export default FormIteamInformation